// src/components/Admin/AdminCreateSellerInvoice.jsx

import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  TextField,
  Button,
  Autocomplete,
  Paper,
  Typography,
  Divider,
  IconButton,
  Grid,
  Box,
  MenuItem,
} from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import { server } from "../../server"; 

const AdminCreateSellerInvoice = () => {
  const [sellerOptions, setSellerOptions] = useState([]);
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [items, setItems] = useState([
    {
      name: "",
      description: "",
      qty: 1,
      pricePerQty: "Nos", // Default unit
      pricePerQtyWithoutGST: "",
      gstPercentage: "",
      hsnCode: "",
      totalPrice: 0,
    },
  ]);
  const [shippingCharges, setShippingCharges] = useState(0);
  const [totalValueWithoutGst, setTotalValueWithoutGst] = useState(0);
  const [totalGstValue, setTotalGstValue] = useState(0);
  const [totalInvoiceValue, setTotalInvoiceValue] = useState(0);
  const [purchaseOrderNumber, setPurchaseOrderNumber] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("Pay on Credit");
  const [invoiceDate, setInvoiceDate] = useState(() => {
    const today = new Date().toISOString().split("T")[0];
    return today;
  });
  const [invoiceNumber, setInvoiceNumber] = useState("");


  useEffect(() => {
   
    calculateTotals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    calculateTotals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, shippingCharges]);

 

  const handleSellerSearch = async (event, value) => {
    const query = value;
    if (query && query.length >= 1) {
      try {
        const response = await axios.get(`${server}/shop/search?query=${query}`, {
          withCredentials: true,
        });
        if (response.data.success) {
          setSellerOptions(response.data.shops);
        }
      } catch (error) {
        console.error("Error fetching seller options:", error);
      }
    } else {
      setSellerOptions([]);
    }
  };

  const handleSellerSelect = (event, value) => {
    console.log("Selected seller:", value);
    setSelectedSeller(value);
   
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = value;

    // Update totalPrice for the item
    if (["qty", "pricePerQtyWithoutGST", "gstPercentage"].includes(field)) {
      const qty = parseFloat(updatedItems[index].qty) || 0;
      const pricePerQtyWithoutGST = parseFloat(updatedItems[index].pricePerQtyWithoutGST) || 0;
      const gstPercentage = parseFloat(updatedItems[index].gstPercentage) || 0;

      const priceWithoutGst = qty * pricePerQtyWithoutGST;
      const gstValue = (priceWithoutGst * gstPercentage) / 100;
      const total = priceWithoutGst + gstValue;

      updatedItems[index].totalPrice = total;
    }

    setItems(updatedItems);
  };

  const handleAddItem = () => {
    setItems([
      ...items,
      {
        name: "",
        description: "",
        qty: 1,
        pricePerQty: "Nos",
        pricePerQtyWithoutGST: "",
        gstPercentage: "",
        hsnCode: "",
        totalPrice: 0,
      },
    ]);
  };

  const handleRemoveItem = (index) => {
    const updatedItems = items.filter((_, idx) => idx !== index);
    setItems(updatedItems);
  };

  const calculateTotals = () => {
    let totalWithoutGst = 0;
    let totalGst = 0;

    items.forEach((item) => {
      const qty = parseFloat(item.qty) || 0;
      const pricePerQtyWithoutGST = parseFloat(item.pricePerQtyWithoutGST) || 0;
      const gstPercentage = parseFloat(item.gstPercentage) || 0;

      const priceWithoutGst = qty * pricePerQtyWithoutGST;
      const gstValue = (priceWithoutGst * gstPercentage) / 100;

      totalWithoutGst += priceWithoutGst;
      totalGst += gstValue;
    });

    const totalValue = totalWithoutGst + totalGst + parseFloat(shippingCharges || 0);

    setTotalValueWithoutGst(totalWithoutGst.toFixed(2));
    setTotalGstValue(totalGst.toFixed(2));
    setTotalInvoiceValue(totalValue.toFixed(2));
  };

  const handleSubmit = async () => {
    if (!selectedSeller) {
      alert("Please select a seller.");
      return;
    }

    if (!purchaseOrderNumber) { 
      alert("Please enter a Purchase Order Number.");
      return;
    }

    if (!invoiceDate) {
      alert("Please select an invoice date.");
      return;
    }

    // Prepare items data
    const itemsData = items.map((item, index) => {
      const qty = parseFloat(item.qty) || 0;
      const pricePerQtyWithoutGST = parseFloat(item.pricePerQtyWithoutGST) || 0;
      const gstPercentage = parseFloat(item.gstPercentage) || 0;

      const priceWithoutGst = qty * pricePerQtyWithoutGST;
      const gstValue = (priceWithoutGst * gstPercentage) / 100;
      const totalPrice = priceWithoutGst + gstValue;

      return {
        name: item.name,
        description: item.description,
        qty: qty,
        gstPercentage: gstPercentage,
        pricePerQty: item.pricePerQty, // Unit
        totalPrice: priceWithoutGst.toFixed(2),
        hsnCode: item.hsnCode,
        sno: index + 1,
        discountPriceWithCommission: pricePerQtyWithoutGST.toFixed(2), // Price without GST
        totalPriceWithCommission: totalPrice.toFixed(2),
      };
    });

    // Calculate totalValueWithCommission
    const totalValueWithCommission = parseFloat(totalValueWithoutGst) + parseFloat(totalGstValue);

    const sellerInvoiceData = {
      sellerId: selectedSeller._id,
 // Include shipping address
      items: itemsData,
      shippingCharges: parseFloat(shippingCharges),
      totalValueWithoutGst: parseFloat(totalValueWithoutGst),
      totalGstValue: parseFloat(totalGstValue),
      totalInvoiceValue: parseFloat(totalInvoiceValue),
      totalValueWithCommission: parseFloat(totalValueWithCommission),
      purchaseOrderNumber, // Purchase Order Number
      paymentMethod,
      invoiceDate, 
      invoiceNumber,
    };

    try {
      const response = await axios.post(`${server}/sellerInvoice/create-seller-invoice`, sellerInvoiceData, {
        withCredentials: true,
      });
      if (response.data.success) {
        alert("Seller Invoice created successfully!");
        // Reset the form
        setSelectedSeller(null);
    
        setItems([
          {
            name: "",
            description: "",
            qty: 1,
            pricePerQty: "Nos",
            pricePerQtyWithoutGST: "", 
            gstPercentage: "",
            hsnCode: "",
            totalPrice: 0,
          },
        ]);
        setShippingCharges(0);
        setPurchaseOrderNumber("");
        setPaymentMethod("Pay on Credit");
        setTotalValueWithoutGst(0);
        setTotalGstValue(0);
        setTotalInvoiceValue(0);
        setInvoiceDate(new Date().toISOString().split("T")[0]);
        setInvoiceNumber("");
       
        
      }
    } catch (error) {
      console.error("Error creating seller invoice:", error);
      alert("Failed to create seller invoice.");
    }
  };

  return (
    <Paper sx={{ padding: 4, margin: "20px auto", maxWidth: "1200px" }}>
      <Typography variant="h4" gutterBottom>
        Purchase Invoice Entry
      </Typography>
      <Divider sx={{ marginY: 2 }} />

      {/* Seller, Invoice Date, and Invoice Number */}
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Autocomplete
            options={sellerOptions}
            getOptionLabel={(option) => `${option.name} - ${option.email}`}
            onInputChange={handleSellerSearch}
            onChange={handleSellerSelect}
            renderInput={(params) => <TextField {...params} label="Search Seller" variant="outlined" />}
            fullWidth
            value={selectedSeller}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Invoice Date"
            type="date"
            variant="outlined"
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            value={invoiceDate}
            onChange={(e) => setInvoiceDate(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={3}>
        <TextField
  label="Invoice Number"
  variant="outlined"
  fullWidth
  value={invoiceNumber}
  onChange={(e) => setInvoiceNumber(e.target.value)}
/>

        </Grid>
      </Grid>

      {selectedSeller && (
        <Box sx={{ marginTop: 3 }}>
          <Typography variant="h6">Seller Details</Typography>
          <Grid container spacing={2} sx={{ marginTop: 1 }}>
            <Grid item xs={12} sm={6}>
              <Typography>
                <strong>Name:</strong> {selectedSeller.name}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography>
                <strong>Email:</strong> {selectedSeller.email}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography>
                <strong>Phone Number:</strong> {selectedSeller.phoneNumber}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography>
                <strong>GST Number:</strong> {selectedSeller.gstNumber}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>
                <strong>Billing Address:</strong> {selectedSeller.billingAddress}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography>
                <strong>Zip Code:</strong> {selectedSeller.zipCode}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      )}

      {/* Invoice Details */}
      <Box sx={{ marginTop: 4 }}>
        <Typography variant="h6">Invoice Details</Typography>
        <Grid container spacing={4} sx={{ marginTop: 1 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Purchase Order Number"
              variant="outlined"
              fullWidth
              value={purchaseOrderNumber}
              onChange={(e) => setPurchaseOrderNumber(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              label="Payment Method"
              variant="outlined"
              fullWidth
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
            >
              <MenuItem value="Razorpay">Razorpay</MenuItem>
              <MenuItem value="Cash Paid">Cash Paid</MenuItem>
              <MenuItem value="Pay on Credit">Pay on Credit</MenuItem>
            </TextField>
          </Grid>
        </Grid>
      </Box>

      {/* Items */}
      <Box sx={{ marginTop: 4 }}>
        <Typography variant="h6">Items</Typography>
        {items.map((item, index) => (
          <Paper
            key={index}
            sx={{ padding: 2, marginTop: 2, backgroundColor: "#f9f9f9" }}
            elevation={3}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Item Name"
                  variant="outlined"
                  fullWidth
                  value={item.name}
                  onChange={(e) => handleItemChange(index, "name", e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Description"
                  variant="outlined"
                  fullWidth
                  value={item.description}
                  onChange={(e) => handleItemChange(index, "description", e.target.value)}
                />
              </Grid>
              <Grid item xs={6} sm={2}>
                <TextField
                  label="Quantity"
                  variant="outlined"
                  type="number"
                  fullWidth
                  value={item.qty}
                  onChange={(e) => handleItemChange(index, "qty", e.target.value)}
                />
              </Grid>
              <Grid item xs={6} sm={2}>
                <TextField
                  label="Price / Qty (Without GST)"
                  variant="outlined"
                  type="number"
                  fullWidth
                  value={item.pricePerQtyWithoutGST}
                  onChange={(e) =>
                    handleItemChange(index, "pricePerQtyWithoutGST", e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={6} sm={2}>
                <TextField
                  select
                  label="Price per Unit"
                  variant="outlined"
                  fullWidth
                  value={item.pricePerQty}
                  onChange={(e) => handleItemChange(index, "pricePerQty", e.target.value)}
                >
                  {[
                    "Nos",
                    "Kilogram",
                    "Gram",
                    "Meter",
                    "Millimeter",
                    "Centimeter",
                    "Foot",
                    "Square foot",
                    "Litre",
                    "Millilitre",
                    "Cubic meter",
                    "Dozen",
                  ].map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={6} sm={2}>
                <TextField
                  label="GST (%)"
                  variant="outlined"
                  type="number"
                  fullWidth
                  value={item.gstPercentage}
                  onChange={(e) => handleItemChange(index, "gstPercentage", e.target.value)}
                />
              </Grid>
              <Grid item xs={6} sm={2}>
                <TextField
                  label="HSN Code"
                  variant="outlined"
                  fullWidth
                  value={item.hsnCode}
                  onChange={(e) => handleItemChange(index, "hsnCode", e.target.value)}
                />
              </Grid>
              <Grid item xs={6} sm={2}>
                <TextField
                  label="Total Price"
                  variant="outlined"
                  type="number"
                  fullWidth
                  value={item.totalPrice.toFixed(2)}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <IconButton color="error" onClick={() => handleRemoveItem(index)}>
                  <Remove />
                </IconButton>
                {index === items.length - 1 && (
                  <IconButton color="primary" onClick={handleAddItem}>
                    <Add />
                  </IconButton>
                )}
              </Grid>
            </Grid>
          </Paper>
        ))}
      </Box>

      {/* Shipping and Totals */}
      <Box sx={{ marginTop: 4 }}>
        <Typography variant="h6">Additional Charges & Totals</Typography>
        <Grid container spacing={4} sx={{ marginTop: 1 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Additional Shipping Charges"
              variant="outlined"
              type="number"
              fullWidth
              value={shippingCharges}
              onChange={(e) => setShippingCharges(e.target.value)}
            />
          </Grid>
        </Grid>
        <Divider sx={{ marginY: 2 }} />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Typography>
              <strong>Total Value (Without GST):</strong> Rs {totalValueWithoutGst}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography>
              <strong>Total GST Value:</strong> Rs {totalGstValue}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography>
              <strong>Total Invoice Value:</strong> Rs {totalInvoiceValue}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Action Buttons */}
      <Box sx={{ marginTop: 4, display: "flex", justifyContent: "flex-end", gap: 2 }}>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => {
            // Optional: Implement reset functionality
            if (window.confirm("Are you sure you want to reset the form?")) {
              setSelectedSeller(null);
              
              setItems([
                {
                  name: "",
                  description: "",
                  qty: 1,
                  pricePerQty: "Nos",
                  pricePerQtyWithoutGST: "",
                  gstPercentage: "",
                  hsnCode: "",
                  totalPrice: 0,
                },
              ]);
              setShippingCharges(0);
              setPurchaseOrderNumber("");
              setPaymentMethod("Cash On Delivery");
              setTotalValueWithoutGst(0);
              setTotalGstValue(0);
              setTotalInvoiceValue(0);
              setInvoiceDate(new Date().toISOString().split("T")[0]);
              setInvoiceNumber("");
              
            }
          }}
        >
          Reset
        </Button>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Create Purchase Invoice
        </Button>
      </Box>
    </Paper>
  );
};

export default AdminCreateSellerInvoice;

